import { useMediaQuery } from '@mui/material'
import { theme } from 'src/theme'

interface UseDevicesReturn {
  isSmallScreen: boolean
  isLargeScreen: boolean
  isDesktop: boolean
  isTablet: boolean
  isMobile: boolean
}

export default function useDevices(): UseDevicesReturn {
  const { lg, md, sm } = theme.breakpoints.values
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1024))
  const isLargeScreen = useMediaQuery(theme.breakpoints.up(lg))
  const isDesktop = useMediaQuery(theme.breakpoints.up(md))
  const isTablet = useMediaQuery(theme.breakpoints.down(md))
  const isMobile = useMediaQuery(theme.breakpoints.down(sm))

  return {
    isSmallScreen,
    isLargeScreen,
    isDesktop,
    isTablet,
    isMobile
  }
}
